export interface FontOverrides {
    fontStyle?: string
    fontWeight?: string
    fontSize?: string
    fontFamily?: string
}

export interface DecoratedStyleProperty {
    value?: string
    additionalData?: Record<string, string>
    overrides?: FontOverrides
}

export type DecoratedStyleProperties = Record<string, DecoratedStyleProperty>

export const STYLE_PROPERTY_PREFIXES = ['alpha', 'boxShadowToggleOn']
export const THEME_VAR_PREFIXES = ['font', 'color']
export const STYLE_PROPERTY_SOURCE = {
    THEME: 'theme',
    VALUE: 'value'
}
